// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";
// Models

// Dto
import { BackgroundInformationDTO } from "Globals/Models/DTO/BackgroundInformationDTO";

export class BackgroundInformationModel extends ModelBase<BackgroundInformationModel, BackgroundInformationDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public isBritishOrEUCitizen: boolean = true;
    @MobX.observable public isPassportIndefinite: boolean = true;
    @MobX.observable public visaEndDate: Date | null = null;
    @MobX.observable public ageId: string = "placeholder";
    @MobX.observable public gender: string = "placeholder";
    @MobX.observable public genderAtBirth: string = "placeholder";
    @MobX.observable public ethnicityId: string = "placeholder";
    @MobX.observable public ethnicityOther: string = "";
    @MobX.observable public sexualOrientationId: string = "placeholder";
    @MobX.observable public religionId: string = "placeholder";
    @MobX.observable public disabilityId: string = "placeholder";
    @MobX.observable public disabilityOther: string = "";
    @MobX.observable public specialRequirementsId: string = "placeholder";
    @MobX.observable public nationalityId: string = "placeholder";
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: BackgroundInformationDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.formId = model.formId;
            this.applicantId = model.applicantId;
            this.isBritishOrEUCitizen = model.isBritishOrEUCitizen;
            this.isPassportIndefinite = model.isPassportIndefinite;
            this.visaEndDate = model.visaEndDate;
            this.ageId = model.ageId == "" ? "placeholder" : model.ageId;
            this.gender = model.gender == "" ? "placeholder" : model.gender;
            this.genderAtBirth = model.genderAtBirth == "" ? "placeholder" : model.genderAtBirth;
            this.ethnicityId = model.ethnicityId == "" ? "placeholder" : model.ethnicityId;
            this.ethnicityOther = model.ethnicityOther;
            this.sexualOrientationId = model.sexualOrientationId == "" ? "placeholder" : model.sexualOrientationId;
            this.religionId = model.religionId == "" ? "placeholder" : model.religionId;
            this.disabilityId = model.disabilityId == "" ? "placeholder" : model.disabilityId;
            this.disabilityOther = model.disabilityOther;
            this.specialRequirementsId = model.specialRequirementsId == "" ? "placeholder" : model.specialRequirementsId;
            this.nationalityId = model.nationalityId == "" ? "placeholder" : model.nationalityId;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): BackgroundInformationDTO => {
        let model: BackgroundInformationDTO = {
            id: this.id,
            formId: this.formId,
            applicantId: this.applicantId,
            isBritishOrEUCitizen: this.isBritishOrEUCitizen,
            isPassportIndefinite: this.isPassportIndefinite,
            visaEndDate: this.visaEndDate,
            ageId: this.ageId == "placeholder" ? "" : this.ageId,
            gender: this.gender == "placeholder" ? "" : this.gender,
            genderAtBirth: this.genderAtBirth == "placeholder" ? "" : this.genderAtBirth,
            ethnicityId: this.ethnicityId == "placeholder" ? "" : this.ethnicityId,
            ethnicityOther: this.ethnicityOther,
            sexualOrientationId: this.sexualOrientationId == "placeholder" ? "" : this.sexualOrientationId,
            religionId: this.religionId == "placeholder" ? "" : this.religionId,
            disabilityId: this.disabilityId == "placeholder" ? "" : this.disabilityId,
            disabilityOther: this.disabilityOther,
            specialRequirementsId: this.specialRequirementsId == "placeholder" ? "" : this.specialRequirementsId,
            nationalityId: this.nationalityId == "placeholder" ? "" : this.nationalityId,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };
}
